<template lang="html">
<span>
    <div v-if="establishment.logo === ''" class="myicon">
        <i class="fa fa-hotel"></i>
    </div>
    <div v-else :style="logo_style" class="logo card-img sh-6 sw-6"/>
</span>
</template>

<script>
import filters from "@/filters.js";

export default {
  name: "EstablishmentLogo",
  props: {
    establishment: Object,
    rounded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    logo_style() {
      let ret = "";
      if (this.establishment && this.establishment.logo && this.establishment.logo !== "") {
        ret = this.establishment.logo;
      }
      const border_radius = this.rounded === true ? "50%" : "0%";
      return {
        "background-image": filters.filters.as_css_background_string(ret),
        "border-radius": border_radius
      };
    }
  },
  methods: {},
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.logo {
  width: 50px;
  height: 50px;
  border: 0px solid black;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 100% !important;
}

.myicon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
